import * as React from "react";

import {
  InsuranceType,
  ProductBackendName,
} from "Components/Features/CheckPrice/Products/productTypes";

import Accordion, { Row } from "@storeblocks/accordion";
import { CoverageComparisonAccordion } from "Components/Features/CheckPrice/Tiles/ProductPriceTile/Coverages/CoverageComparisonAccordion";
import { CoverageComparisonTable } from "Components/Features/CheckPrice/Tiles/ProductPriceTile/Coverages/CoverageComparisonTable";
import { InsuranceCoverage } from "Store/interfaces/products/coverage";
import { useComponentTexts } from "Store/texts/hooks";
import { buttonTrackId } from "Utils/analytics";
import { shouldUseTableComparison } from "./coverageComparisonUtils";

interface Props {
  readonly productBackendName: ProductBackendName;
  readonly selectedCoverage: InsuranceCoverage;
  readonly doNotShow?: InsuranceType;
}

export const CoverageComparison = ({
  productBackendName,
  selectedCoverage,
  doNotShow,
}: Props): React.ReactElement => {
  const [{ coverageAccordion }, lang] = useComponentTexts();
  const Variant = shouldUseTableComparison(productBackendName)
    ? CoverageComparisonTable
    : CoverageComparisonAccordion;

  return (
    <>
      <Accordion borderTop={false}>
        <Row
          id={buttonTrackId("coverage-comparison")}
          data-trackid={buttonTrackId("coverage-comparison")}
          header={coverageAccordion.comparison[lang]}
          headerProps={{ type: "button" }}
        >
          <Variant
            product={productBackendName}
            selected={selectedCoverage}
            doNotShow={doNotShow}
          />
        </Row>
      </Accordion>
    </>
  );
};
